import { render } from "./DataSetting.vue?vue&type=template&id=4d043042&scoped=true"
import script from "./DataSetting.vue?vue&type=script&lang=js"
export * from "./DataSetting.vue?vue&type=script&lang=js"

import "./DataSetting.vue?vue&type=style&index=0&id=4d043042&scoped=true&lang=css"

import exportComponent from "D:\\others\\ysj\\leer\\wisdom\\html\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d043042"]])

export default __exports__